import { Component, OnInit } from '@angular/core';
import { PushNotificationsService } from 'angular2-notifications';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageBag, ValidationMessagesService } from 'ng2-custom-validation';
import { WebApiObservableService } from 'app/web-api-observable/web-api-observable.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.css']
})
export class CartComponent implements OnInit {

  constructor(private _pushNotifications: PushNotificationsService, private router: Router, private fb: FormBuilder,
    private validationMessagesService: ValidationMessagesService, private CommonService: WebApiObservableService) {
    _pushNotifications.requestPermission();
  }

  shoppingcart = [];
  total: any;
  subtotal: any;
  foods_ordered = [];
  loggedinUser: any = [];
  delivery = 10;
  capcharesult: any;
  capcha: any;
  loginForm: FormGroup;
  registerForm: FormGroup;
  new: Object = {};
  user: Object = {};
  errors: MessageBag = new MessageBag();
  loginError = '';
  errorMessage: any[] = [];
  UserLoggedIn: any;
  logged_in_user: any;
  ngOnInit() {
    this.shoppingcart = JSON.parse(localStorage.getItem('SHOPPING_CART'));
   console.log(this.shoppingcart);
    this.foods_ordered = this.shoppingcart[0].fooditems;
    this.subtotal = this.shoppingcart[0].subtotal;
    this.total = this.shoppingcart[0].total;

    this.loginForm = this.fb.group({
      'mobile': ['', [
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(10)
      ]],
      'password': ['', [
        Validators.required,
        Validators.minLength(6)
      ]]
    });
    this.validationMessagesService
      .seeForErrors(this.loginForm)
      .subscribe((errors: MessageBag) => {
        this.errors = errors;
      });

    this.registerForm = this.fb.group({
      'name': ['', [
        Validators.required,
        Validators.minLength(2)

      ]],
      'username': ['', [
        Validators.required,
        Validators.minLength(6)
      ]],
      'email': ['', [
        Validators.required,
        Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/)
      ]],
      'mobile': ['', [
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(10)
      ]],
      'password': ['', [
        Validators.required,
        Validators.minLength(6)
      ]],
      'capcha': ['', [
        Validators.required
      ]],

    });
    this.validationMessagesService
      .seeForErrors(this.registerForm)
      .subscribe((errors: MessageBag) => {
        this.errors = errors;
      });

    /*Calling Api for generating Capcha*/
    this.CommonService
      .getCapchaService('/users/generate-random-string')
      .subscribe(
      result => this.capcharesult = result,
      error => this.errorMessage = <any>error
      );
  }

  delete(food) {
    const index: number = this.foods_ordered.indexOf(food);
    this.foods_ordered.splice(index, 1);
    this.subtotal -= food.food.priceVal;
    this.total -= food.food.priceVal;
  }

  onPlusitem(index: number) {
    this.foods_ordered[index].food.itemsval += 1;
    this.foods_ordered[index].food.priceVal = this.foods_ordered[index].food.price * this.foods_ordered[index].food.itemsval;
  }

  onMinusitem(index: number) {
    this.foods_ordered[index].food.itemsval -= 1;
    this.foods_ordered[index].food.priceVal = this.foods_ordered[index].food.price * this.foods_ordered[index].food.itemsval;
  }

  calculateSubtotal() {
    this.subtotal = 0;
    for (let i = 0; i < this.foods_ordered.length; i++) {
      this.subtotal += this.foods_ordered[i].food.priceVal;
    }
    return this.subtotal;
  }

  calculateTotal() {
    this.total = 0;

    for (let i = 0; i < this.foods_ordered.length; i++) {
      this.total += this.foods_ordered[i].food.priceVal;
    }
    this.total = this.delivery + this.total;

    return this.total;
  }

  proceedCheckout() {
    this.loggedinUser = localStorage.getItem('LOGGED_IN_USER');

    if (this.loggedinUser === null) {
      //  alert('Please Login or Register to Continue');
      //  let options = {
      //     body: "Please Login or Register to Continue",
      //     icon:'http://test.eatasiafood.com/uploads/logo/logo.png',                   
      // }
      // let notify = this._pushNotifications.create('Error', options).subscribe( 
      //  );
      this.shoppingcart = [];
      this.shoppingcart.push({ 'fooditems': this.foods_ordered, 'subtotal': this.subtotal, 'total': this.total })
      localStorage.setItem('SHOPPING_CART', JSON.stringify(this.shoppingcart));
      document.getElementById("openModalButton").click();
    } else {
      this.loggedinUser = JSON.parse(this.loggedinUser);

      this.shoppingcart = [];
      this.shoppingcart.push({ 'fooditems': this.foods_ordered, 'subtotal': this.subtotal, 'total': this.total })
      localStorage.setItem('SHOPPING_CART', JSON.stringify(this.shoppingcart));

      this.router.navigate(["checkout"]);
    }
  }

  refresh() {
    this.loginForm.reset();
    this.registerForm.reset();
  }
  OnLogin(myModal) {
    $('.spin').addClass('loading');
    this.CommonService
      .createService('/users/login', this.user)
      .subscribe(
      result => {
        this.logged_in_user = result.user;
        localStorage.setItem('AUTH_TOKEN', result.auth_token);
        localStorage.setItem('LOGGED_IN_USER', JSON.stringify(result.user));
        myModal.close();

        this.UserLoggedIn = JSON.parse(localStorage.getItem('LOGGED_IN_USER'));
         window.location.reload();
        $('.spin').removeClass('loading');
        let options = {
          body: "Login Successful",
          icon: 'http://test.eatasiafood.com/uploads/logo/logo.png',
        }
        let notify = this._pushNotifications.create('Success', options).subscribe(
        );
       
      },
      error => {
        $('.spin').removeClass('loading');
        this.loginError = <any>error
      }
      );
  }

  OnSubmit(myModal) {

    if (this.capcharesult === this.capcha) {
      $('.spin').addClass('loading');
      this.CommonService
        .createService('/users', this.new)
        .subscribe(
        result => {
          this.logged_in_user = result;
          localStorage.setItem('AUTH_TOKEN', result.auth_key);
          localStorage.setItem('LOGGED_IN_USER', JSON.stringify(result));
          myModal.close();
           window.location.reload(); 
          $('.spin').removeClass('loading');
          this.UserLoggedIn = JSON.parse(localStorage.getItem('LOGGED_IN_USER'));
          let options = {
            body: "Registeration Successful",
            icon: 'http://test.eatasiafood.com/uploads/logo/logo.png',
          }
          let notify = this._pushNotifications.create('Success', options).subscribe(
          );
          
        },
        error => {
          $('.spin').removeClass('loading');
          this.errorMessage = <any>error;
        }
        );
    } else {
      alert('Wrong Capcha Entered');
    }

  }


}



// WEBPACK FOOTER //
// D:/deliverproject/eatasiafood/src/app/cart/cart.component.ts